export const enum TOAST_TYPE {
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
}

export const TIMEOUT = 10000;
